'use strict';

Object.defineProperty(exports, "__esModule", {
            value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _fecha = require('./fecha.config');

var _fecha2 = _interopRequireDefault(_fecha);

var _paginacion = require('./paginacion.config');

var _paginacion2 = _interopRequireDefault(_paginacion);

var _sugerencia = require('./sugerencia.config');

var _sugerencia2 = _interopRequireDefault(_sugerencia);

var _url = require('./url.config');

var _url2 = _interopRequireDefault(_url);

var _tipoBusqueda = require('./tipo-busqueda.config');

var _tipoBusqueda2 = _interopRequireDefault(_tipoBusqueda);

var _tipoRegistro = require('./tipo-registro.config');

var _tipoRegistro2 = _interopRequireDefault(_tipoRegistro);

var _campoBusqueda = require('./campo-busqueda.config');

var _campoBusqueda2 = _interopRequireDefault(_campoBusqueda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'buscador.config';

var ngModule = _angular2.default.module(MODULE_NAME, []);

ngModule.constant('urlConfig', _url2.default).constant('paginacionConfig', _paginacion2.default).constant('fechaConfig', _fecha2.default).constant('tipoBusquedaConfig', _tipoBusqueda2.default).constant('tipoRegistroConfig', _tipoRegistro2.default).constant('campoBusquedaConfig', _campoBusqueda2.default).constant('sugerenciaConfig', _sugerencia2.default);

exports.default = MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/config/index.js